






































import {
  Component,
  Vue
} from "vue-property-decorator";
import axios from '@/axios-auth';
import { Getter } from 'vuex-class';
import { loginData } from '@/types'

@Component
export default class Login extends Vue {
  public password: string = '';
  public username: string = '';
  @Getter public isError: boolean;

  login(): void {
    const data: loginData = {
      password: this.password,
      email: this.username + '@gmail.com',
    }
    this.$store.dispatch('login', data);
  }
}
